<template>
    <span :class="dateClass" v-if="date && timezone">
        {{ convertToTimezone(date, timezone) }}
    </span>
    <span v-else-if="stageNumber" class="tag is-outlined" :class="stageNumberClass">
        {{ translate("admin_payment.stage_number") }} #{{ stageNumber }}
    </span>
</template>

<script>
    import translatorMixin from "../../Common/translatorMixin";
    import dateTimeUtilsMixin from "../../Common/dateTimeUtilsMixin";

    export default {
        name: "registration-stage-number",
        mixins: [translatorMixin, dateTimeUtilsMixin],
        props: ["stageNumber", "date", "timezone"],
        computed: {
            stageNumberClass() {
                if (this.stageNumber === 1) {
                    return "is-success";
                }
                if (this.stageNumber === 2) {
                    return "is-warning";
                }
                if (this.stageNumber >= 3) {
                    return "is-danger";
                }

                return "";
            },
            dateClass() {
                if (this.stageNumber === 1) {
                    return "has-text-success";
                }
                if (this.stageNumber === 2) {
                    return "has-text-warning";
                }
                if (this.stageNumber >= 3) {
                    return "has-text-danger";
                }

                return "";
            },
        },
    };
</script>

<style scoped></style>
